export default {
  template: require('./library.component.html').default
}
